import { render, staticRenderFns } from "./BudgetList.vue?vue&type=template&id=15ad0bb4&scoped=true&"
import script from "./BudgetList.vue?vue&type=script&lang=js&"
export * from "./BudgetList.vue?vue&type=script&lang=js&"
import style0 from "./BudgetList.vue?vue&type=style&index=0&id=15ad0bb4&lang=scss&scoped=true&"
import style1 from "./BudgetList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad0bb4",
  null
  
)

export default component.exports